export default class LayoutController {
	constructor($scope) {
		this.scope = $scope;
		this.isElectron = false;
	}
}

LayoutController.$inject = ['$scope'];
